import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility, CustomScrollbarProps} from '../../../../lib/custom-scrollbar/custom-scrollbar';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import retardUpdate from '../../../../lib/react/update-retarder';
import MediaQueryTool from '../../../../lib/tools/media-query-tool';
import {OEMediaCenterItemFactory} from './oe-media-center-item-factory';
import {OEPresentationPlayableFlags} from '../../presentation/oe-presentation-model';
import OEPresentationSlideMagnification, {OEPresentationSlideMagnificationPlacement} from '../../presentation/oe-presentation-slide-magnification';
import OEToolbox from '../../../../lib/tools/oe-toolbox';

export default class OEMediaCenterItemCollection extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.items = [];

        this.magnification = {id: -1, presID: -1, parentRect: null, itemRect: null};

        this.state = {
            items: this.items,
            magnification: clone(this.magnification)
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onPresentationAdded = this.onPresentationAdded.bind(this);
        this.onPresentationRemoved = this.onPresentationRemoved.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);

        this.onRef = this.onRef.bind(this);
        this.onScrollbarRef = this.onScrollbarRef.bind(this);
        this.onElementRef = this.onElementRef.bind(this);

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onContentResize = this.onContentResize.bind(this);
        this.onItem = this.onItem.bind(this);
        this.onItemClicked = this.onItemClicked.bind(this);
        this.onItemMouseEnter = this.onItemMouseEnter.bind(this);
        this.onItemMouseLeave = this.onItemMouseLeave.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        if(nextProps.items !== this.props.items)    {
            this.updateItems(nextProps);
        }
    }

    componentDidUpdate()    {
        if(this.shouldScrollNextTo)    {
            this.scrollTo(this.shouldScrollNextTo.itemID, this.shouldScrollNextTo.rect);
            delete this.shouldScrollNextTo;
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAdded, this.onPresentationAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationRemoved, this.onPresentationRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAdded, this.onPresentationAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationRemoved, this.onPresentationRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
    }

    updateLanguage()   {
        this.updateItems();
    }

    updatePresentations()   {
        const controller = this.oe.sharedInterface.getUIControllerPresentation();
        const presentations = controller.getPresentationDataList();

        this.presentations = {};

        for(let i = 0; i < presentations.length; i++) {
            this.presentations[presentations[i].id.toString()] = {id: presentations[i].id, name: presentations[i].name, desc: presentations[i].description};
        }
    }

    updateItemsForPresentations()  {
        if(!this.oe.isReady() || !this.presentations)  return;
        
        const Type = this.oe.Module.MediaCenterItemType;
        this.items = this.items.map((item) => {
            let pres = item.type === Type.presentation ? this.presentations[item.item.index.toString()] : null;
            return {
                id: item.id,
                type: item.type,
                layoutType: item.layoutType,
                showNumber: item.showNumber,
                showLabel: item.showLabel,
                icon: item.icon,
                label: pres && pres.name.get() ? pres.name.get() : item.label_,
                label_: item.label_,
                desc: pres && pres.desc.get() ? pres.desc.get() : null,
                img: item.img,
                item: item.item
            }
        });

        this.setState({items: this.items});
    }

    updateItems(props)   {
        if(!this.oe.isReady() || !this.presentations)  return;
        props = props || this.props;

        const si = this.oe.sharedInterface;
        const Type = this.oe.Module.MediaCenterItemType;

        let resourcePath = 'app/oe/' + this.oe.Module.filePackagePathURL;

        this.items = props.items.map((item) => {
            let img = null;
            let label = si.getLocalizedStringEnc(item.label);
            let pres = item.type === Type.presentation ? this.presentations[item.index.toString()] : null;
            
            img = item.thumbImagePath !== '' ? item.thumbImagePath : (item.previewImagePath !== '' ? item.previewImagePath : (item.type === Type.image ? item.path : null));
            if(img) img = resourcePath +  si.getLocalizedStringEnc(img);

            let icon = {
                type: item.icon.type.value,
                code: item.icon.type === this.oe.Module.MediaCenterIconType.text ? si.getLocalizedStringEnc(item.icon.code) : item.icon.code,
                color: item.icon.color
            };

            return {
                id: item.id,
                type: item.type,
                layoutType: item.layoutType.value,
                showNumber: item.showNumber,
                showLabel: item.showLabel,
                icon: icon,
                label: pres && pres.name.get() ? pres.name.get() : label,
                label_: label,
                desc: pres && pres.desc.get() ? pres.desc.get() : null,
                img: img,
                item: item
            };
        });

        this.setState({items: this.items});

        this.resetMagnification();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.presentations = undefined;
            this.items = [];
            this.magnification.id = -1;
            this.magnification.presID = -1;
            this.setState({items: this.items, magnification: clone(this.magnification)});
            return;
        }

        retardUpdate(this, () => {
            this.updatePresentations();
            this.updateItems();
            this.updateLanguage();
        });
    }

    resetMagnification()    {
        this.magnification.id = -1;
        this.magnification.presID = -1;
        this.setState({magnification: clone(this.magnification)});
    }

    updateMagnification(id) {
        if(!this.oe.isReady())  return;

        id = typeof(id) === 'number' ? id : -1;

        let item = this.items.find(item => item.id === id);
        let presID = item && item.type === this.oe.Module.MediaCenterItemType.presentation ? item.item.index : -1;

        if(this.magnification.id === id && this.magnification.presID === presID)   {
            this.updateMagnificationRects();
            return;
        }

        this.magnification.id = id;
        this.magnification.presID = presID;
        this.setState({magnification: clone(this.magnification)});
        this.updateMagnificationRects();
    }

    updateMagnificationRects()  {
        let id = this.magnification.id;

        let magnification = clone(this.magnification);

        if(id >= 0) {
            let itemElement = this['item' + id.toString() + 'Element'];
            if(itemElement)    magnification.itemRect = OEToolbox.rectFromDOMRect(itemElement.getBoundingClientRect());
        }

        if(this.ref)    magnification.parentRect = OEToolbox.rectFromDOMRect(this.ref.getBoundingClientRect());

        if(OEToolbox.shallowEqual(this.magnification, magnification, true)) return;

        this.magnification = magnification;
        this.setState({magnification: clone(this.magnification)});
    }

    onPresentationAdded(message, userInfo)   {
        let pres = userInfo.presData;
        this.presentations[pres.id.toString()] = {id: pres.id, name: pres.name, desc: pres.description};
        this.updateItemsForPresentations();
        this.resetMagnification();
    }

    onPresentationRemoved(message, userInfo)   {
        delete this.presentations[userInfo.presID.toString()];
        this.resetMagnification();
    }

    onPresentationDataChanged(message, userInfo)   {
        // if(!(userInfo.changeFlags & (this.oe.Module.PresentationDataChangeFlags.name.value | this.oe.Module.PresentationDataChangeFlags.desc.value)))  return;   // there seems to be some problem with PresentationDataChangeFlags.name 

        let pres = userInfo.presData;
        this.presentations[pres.id.toString()] = {id: pres.id, name: pres.name, desc: pres.description};
        this.updateItemsForPresentations();
    }

    scrollTo(itemID, rect)    {
        if(itemID < 0 || !this.scrollbar) return;
        let item = this['item' + itemID.toString() + 'Element'];
        if(!item) return;

        let additionalOffset = rect ? (rect.x + rect.width * 0.5) : 0.5 * item.offsetWidth;

        let itemCenter = item.offsetLeft + additionalOffset;
        let scrollViewCenter = 0.5*this.scrollbar.getClientWidth();
        this.scrollbar.scrollLeft(itemCenter - scrollViewCenter);

        additionalOffset = rect ? (rect.y + rect.height * 0.5) : 0.5 * item.offsetHeight;

        itemCenter = item.offsetTop + additionalOffset;
        scrollViewCenter = 0.5*this.scrollbar.getClientHeight();
        this.scrollbar.scrollTop(itemCenter - scrollViewCenter);
    }

    scrollNextTo(itemID, rect)    {
        this.shouldScrollNextTo = {itemID: itemID, rect: rect};
        this.forceUpdate();
    }

    onRef(ref) {
        this.ref = ref;
    }

    onScrollbarRef(ref) {
        this.scrollbar = ref;
    }

    onElementRef(ref, id) {
        this['item' + id.toString() + 'Element'] = ref;
    }

    render() {
        const itemViews = this.state.items.map((item, index) =>
            <OEMediaCenterItemFactory
                moduleId={this.props.moduleId}
                {...this.props.config}
                key={item.id}
                index={index}
                item={item}
                className={this.props.itemClassName}
                style={this.props.itemStyle}
                enabled={this.props.enabled}
                selected={index === this.props.selectedItemIndex}
                elementRef={this.onElementRef}
                onItem={this.onItem}
                onClick={this.onItemClicked}
                onMouseEnter={this.onItemMouseEnter}
                onMouseLeave={this.onItemMouseLeave}
            />
        );

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div
                    className={'media-center-item-collection ' + this.props.className}
                    style={this.props.style}
                    ref={this.onRef}
                >
                    <OEResizeObserver onResize={this.onResize}/>

                    <CustomScrollbar
                        {...this.props.scrollbar}
                        onScroll={this.onScroll}
                        onContentResize={this.onContentResize}
                        ref={this.onScrollbarRef}
                    >
                        <div className='media-center-item-collection-container'>{itemViews}</div>
                    </CustomScrollbar>

                    <OEPresentationSlideMagnification
                        className={this.props.magnificationClassName}
                        moduleId={this.props.moduleId}
                        enabled={this.props.magnification > 1 && !this.props.config.usePresItems}
                        visible={true}
                        magnification={this.props.magnification}
                        placement={this.props.magnificationPlacement}
                        presID={this.state.magnification.presID}
                        firstSlide={true}
                        parentRect={this.state.magnification.parentRect}
                        itemRect={this.state.magnification.itemRect}
                    />
                </div>
            </React.Fragment>
        );
    }

    onResize(sender, size)  {
        this.updateMagnificationRects();
        if(this.props.onResize)  this.props.onResize(size);
    }

    onContentResize(sender, size)  {
        if(this.props.onContentResize)  this.props.onContentResize(size);
        if(this.props.scrollbar.onContentResize)   this.props.scrollbar.onContentResize(sender, size);
    }

    onScroll(...args)  {
        this.updateMagnificationRects();
        if(this.props.scrollbar.onScroll)   this.props.scrollbar.onScroll(...args);
    }

    onItem(index, id, subId, rect) {
        // this function gets also called while some update process of the content is happening and the scroll view size being reported by the DOM is misleading
        // as a workaround we defer the scrolling to the next componentDidUpdate
        this.scrollNextTo(id, rect);
    }

    onItemClicked(index, id, subId)   {
        if(this.props.onClick)  this.props.onClick(index, id, subId);
    }

    onItemMouseEnter(index, id)    {
        if(!(MediaQueryTool.hasPrimaryHover && MediaQueryTool.hasPrimaryFinePointer)) return;     // no magnification for devices without touch input
        this.updateMagnification(id);
    }

    onItemMouseLeave(index, id)    {
        this.resetMagnification();
    }
}

OEMediaCenterItemCollection.defaultProps = {
    className:                          '',
    magnificationClassName:             '',
    moduleId:                           '',
    enabled:                            true,
    items:                              [],
    selectedItemIndex:                  -1,
    config: {
        usePresItems:                   true,
        showIndex:                      true,
        forceShowIndex:                 false,
        showIcon:                       true,
        showLabel:                      true,
        showStats:                      false,
        noImages:                       false,
        noPresThumbImages:              false,
        presPlayableFlags:              OEPresentationPlayableFlags.all
    },
    magnification:                      1,
    magnificationPlacement:             OEPresentationSlideMagnificationPlacement.top,
    scrollbar: {
        horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.always,
        verticalTrackVisiblity:         CustomScrollbarTrackVisibility.none,
    }
};

OEMediaCenterItemCollection.propTypes = {
    className:                          PropTypes.string,
    magnificationClassName:             PropTypes.string,
    style:                              PropTypes.object,
    moduleId:                           PropTypes.string,
    enabled:                            PropTypes.bool,
    items:                              PropTypes.array,
    selectedItemIndex:                  PropTypes.number,
    itemClassName:                      PropTypes.string,
    itemStyle:                          PropTypes.object,
    config: PropTypes.shape({
        usePresItems:                   PropTypes.bool,
        showIndex:                      PropTypes.bool,
        forceShowIndex:                 PropTypes.bool,
        showIcon:                       PropTypes.bool,
        showLabel:                      PropTypes.bool,
        showStats:                      PropTypes.bool,
        noImages:                       PropTypes.bool,
        noPresThumbImages:              PropTypes.bool,
        presPlayableFlags:              PropTypes.number,
    }),
    magnification:                      PropTypes.number,
    magnificationPlacement:             PropTypes.oneOf(OEPresentationSlideMagnificationPlacement.all),
    scrollbar:                          CustomScrollbarProps.propsDecl,
    onResize: PropTypes.func,
    onContentResize: PropTypes.func,
    onClick: PropTypes.func
};